<template>
  <div>
    <div style="font-size: 14px; color: #606266" class="mb-2">
      <span style="font-size: 14px; color: #606266"
        >Bill No：{{ formData.stockSellNo }}</span
      >
      <el-divider direction="vertical"></el-divider>
      <span>Status：{{ formData.billStatusName }}</span>
      <el-divider direction="vertical"></el-divider>
      <span style="font-size: 14px; color: #606266">
        Create：{{ formData.createByName }} at
        {{ formData.createDate }}
      </span>
      <el-divider direction="vertical"></el-divider>
      <span style="font-size: 14px; color: #606266">
        Modify：{{ formData.modifyByName }} at
        {{ formData.modifyDate }}
      </span>
    </div>
    <el-form
      ref="form"
      size="small"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
    >
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_sales_name') || '外借销售'"
            prop="useSalesCode"
          >
            <dict-select
              clearable
              v-model="formData.useSalesCode"
              filterable
              size="small"
              url="/master/common/dict/baseUserSelect"
              :placeholder="
                $l('tips_form_label_sales_name') || '请选择业务人员'
              "
              :selectedLabel.sync="formData.useSalesName"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_customer') || '收货客户'"
            prop="useCustCode"
          >
            <dict-select
              clearable
              v-model="formData.useCustCode"
              filterable
              url="/master/common/dict/customerSelect"
              :placeholder="$l('tips_form_label_customer') || '请选择客户'"
              style="width:100%"
              :selectedLabel.sync="formData.useCustName"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_borrow_date') || '销售日期'"
            prop="borrowDate"
          >
            <el-date-picker
              style="width:100%"
              size="small"
              v-model="formData.borrowDate"
              value-format="yyyy-MM-dd"
              type="date"
              :placeholder="$l('tips_form_label_borrow_date') || '选择销售日期'"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  props: {
    formData: {
      default: null,
      type: Object,
    },
    disabled: {
      default: true,
      type: Boolean,
    },
  },
  data() {
    return {
      backDialogVisible: false,
      usePlaceParams: { dictType: 'usePlace' },
      rules: {
        useSalesCode: [
          {
            required: true,
            message: this.$l('tips_form_label_sales_name') || '请选择销售人员',
            trigger: 'change',
          },
        ],
        borrowDate: [
          {
            required: true,
            message: this.$l('tips_form_label_borrow_date') || '请选择外借日期',
            trigger: 'change',
          },
        ],
      },
    }
  },
  mounted() {},
  activated() {},
  deactivated() {},
  methods: {
    async getFormData() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) {
        this.$message.error(
          this.$l('INDEX.form_label_any_required_fields_are_not_filled_in') ||
            '有必输字段未填写，请检查'
        )
        return
      }
      return this.formData
    },
  },
}
</script>
